/**
 * Converts an input (Array/Object) into an object with two properties:
 * - object: The input converted to an object with keys as specified by 'key'.
 * - array: The input converted into an array of objects.
 *
 * If the input is not an array of objects or an object, returns:
 * { object: {}, array: [] }
 *
 * @param {Array|Object} input - The input to be converted.
 * @param {string} [key='id'] - The property to use as the key when converting array to object.
 * @returns {{object: Object, array: Array}} The converted object and array.
 */
export const smartStructureConvert = (input, key = 'id') => {
  if (Array.isArray(input)) {
    if (input.every(item => typeof item === 'object' && item !== null && key in item)) {
      const object = input.reduce((acc, item) => {
        acc[item[key]] = item;
        return acc;
      }, {});
      return { object, array: [...input] };
    }
  } else if (typeof input === 'object' && input !== null) {
    const array = Object.keys(input).map(k => ({ [key]: k, ...input[k] }));
    return { object: { ...input }, array };
  }
  console.warn(`Input is neither an array of objects with "${key}" properties nor a valid object.`);
  return { object: {}, array: [] };
};

